import React, { ComponentType, SetStateAction, useCallback, useContext, useEffect, useMemo, useState } from 'react';
// @ts-ignore
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { AppState } from '@om-fe/core/core/types';
import { DisciplineRouteType, getDisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import { Breadcrumbs } from '../components/breadcrumbs/breadcrumbs';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';
import { getMainMarketsLimit, getMainMarketsLimitByWidth } from '@om-fe/core/components/match-list/utils/match-list.utils';
import { PlatformTypes, isBrowser, replaceTemplateStringPlaceholders } from '@om-fe/utils';
import { RouteNames, RouteDetails, EMRoutingContextInterface, EMRoutingContext } from '@om-fe/core/core/routing/utils';
import getConfig, { EnvConfig, OMFE2ConfigModel } from '@om-fe/core/utils/config';
import { MAIN_MARKET_MIN_LIMIT } from '@om-fe/core/components/match-list/utils/match-list.constants';
import { UseSportsNavStore, useSportsNavTopicStoreCreator } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.hooks';
import { SportsNav } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav';
import { SportsNavType, SportsNavCounterType } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.constants';
import { LayoutType } from '@om-fe/widgets/dist/components/nav/nav.constants';
import { SportRouteParams } from '@om-fe/widgets/dist/common/routing/routing.constants';
import { DisciplineLiveStatus, DisciplinesType, TournamentParams, isOutrightDiscipline } from '@om-fe/models';
import { MixedGroupedTournament } from '../components/mixed-grouped/containers/mixed-grouped-tournament/mixed-grouped-tournament';
import { setVirtualStateExtraParams } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import LocationNav, { LocationNavItemRouteParamsMap } from '@om-fe/core/components/nav-secondary/location-nav/location-nav';
import { locationNavSlice, LocationNavStateModel } from '@om-fe/core/components/nav-secondary/location-nav/location-nav.store';
import { navBem } from '@om-fe/widgets/dist/components/nav/nav.utils';
import getSliceName from '@om-fe/core/utils/get-slice-name';
import getSlice from '@om-fe/core/utils/get-slice';
import { RoutingModel } from '@om-fe/core/store/routing';
import { getDisciplineRouteDetails } from '@om-fe/core/components/discipline-anchor/discipline-anchor.utils';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { useEMRouting } from '@om-fe/core/core/routing/with-routing';
import { useReady } from '@om-fe/store';
import { ParentNavItemRouteParamsMap } from '@om-fe/core/components/nav-secondary/parent-nav/parent-nav-item';
import { LocationNavItemModel } from '@om-fe/widgets/dist/widgets/sports-menu/event-navigation-menu/event-navigation-menu.types';
import { MixedGroupedOddsOutrightsTabSelected } from '../components/mixed-grouped/components/tabs/mixed-grouped-odds-outrights-tabs.types';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import NextRaceBannerPage from './next-race/next-race-banner-page';
import NextRaceEventListPage from './next-race/next-race-event-list-page';
import { CustomContentLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import { CustomContentType } from '@om-fe/core/core/widgets/omfe-widgets/model/omfe-widgets-model';
import SportAllLocationContent from '../components/top-bets/components/all-location-content';

interface SportLocationPageStoreProps {
    readonly isLarge?: boolean;
    readonly breakpoints?: Breakpoints;
    readonly deviceType?: PlatformTypes;
    readonly routing: RoutingModel;
    readonly firstItemLocation: LocationNavItemModel;
    readonly isLoggedIn: boolean;
}

export type SportLocationPageProps = SportLocationPageStoreProps
    & RouteComponentProps<{
        readonly disciplineId: string;
        readonly disciplineName: string;
        readonly tournamentName: string;
        readonly tournamentId: string;
        readonly eventCategoryId?: string;
        readonly eventCategoryName?: string;
        readonly locationName?: string;
        readonly locationId?: string;
        readonly bettingOfferIds?: string;
        readonly stake?: string;
        readonly sportLocationName?: string;
        readonly sportLocationId?: string;
}>;

function SportLocationPageComponent(
    {
        match: {
            params: {
                disciplineId,
                disciplineName,
                eventCategoryId,
                sportLocationId,
                sportLocationName,
            },
        },
        isLarge,
        breakpoints,
        deviceType,
        firstItemLocation,
        isLoggedIn,
    }: SportLocationPageProps,
) {
    let sportPageType: DisciplineRouteType;
    const config: OMFE2ConfigModel = getConfig();
    const topicTimezoneOffset: boolean = config.matchListConfig?.topBets?.topicTimezoneOffset ?? false;
    const enabledBetSimulate: boolean = config.simulate?.enabled ?? false;

    const [tournamentId, setTournamentId] = useState('0')
    const useStore: UseSportsNavStore = useSportsNavTopicStoreCreator({
        sportsNavType: SportsNavType.All,
        counterType: SportsNavCounterType.NumberOfEvents,
        showFromAPI: true,
        topicTimezoneOffset,
        enabledBetSimulate,
    });
    const ready: boolean = useReady(useStore);
    const [activeTab, setActiveTab] = useState<string | undefined>(undefined);
    const [activeLocation, setActiveLocation] = useState<string | undefined>(undefined);
    const { gettext, selectedLanguage } = useI18NContext();
    const { getFullPath } = useEMRouting();
    const enabledDisciplinePage: boolean = config?.enabledDisciplinePage ?? false;
    const { getPath } = useContext<EMRoutingContextInterface>(EMRoutingContext);
    const history: History = useHistory();
    const enabledHorseRacing: boolean = config?.enabledHorseRacing ?? false;
    const enabledGreyHound: boolean = config?.enabledGreyHound ?? false;
    const enabledNextRace: boolean = !!((disciplineId === DisciplinesType.HorseRacing && enabledHorseRacing) || (disciplineId === DisciplinesType.GreyHounds && enabledGreyHound))
    const isHyphenatedFullUrl: boolean = !!getConfig().enableHyphenatedUrl?.fullName;
    const displayAllTab: boolean = !!config.locationNavConfig?.displayAllTab && !isOutrightDiscipline(disciplineId) && (disciplineId !== DisciplinesType.PriceBoost);
    const isShowAllLocationContent: boolean =
        !!(
            sportLocationId === '0' && displayAllTab &&
            !isOutrightDiscipline(disciplineId)
        );

    const mainMarketsLimit: number = config.mainMarketsLimit?.responsive
        ? config.mainMarketsLimit?.byWidth && (isBrowser() && window)
            ? getMainMarketsLimitByWidth(window.innerWidth, config.mainMarketsLimit?.breakpointsByWidth)
            : getMainMarketsLimit(breakpoints)
        : MAIN_MARKET_MIN_LIMIT;

    const generateSportsPageUrl = useCallback((params: SportRouteParams): string | undefined => {
        const routeDetails: RouteDetails = getDisciplineRouteDetails({
            childId: enabledNextRace ? '0' : params.childSportId,
            childName: enabledNextRace ? 'all' : params.childSportName,
            disciplineId: params.sportId,
            disciplineName: params.sportName,
            isLive: false,
            disciplineRouteType: getDisciplineRouteType(params),
            gettext,
        });

        return getFullPath(routeDetails.routeName, routeDetails.routeParams);
    }, [getFullPath, gettext]);

    const handleLocation = (locationId: SetStateAction<string | undefined>) => {
        setActiveLocation(locationId);
    }

    const handleSetTournamentParams = useCallback((data: TournamentParams) => {
        setTournamentId(data.tournamentId)
        setActiveTab(data.activeTab);
        setVirtualStateExtraParams(data);
    }, []);

    const handleActiveTabOutrights = useCallback(() => {
        setActiveTab(MixedGroupedOddsOutrightsTabSelected.Outrights);
    }, []);

    const seoUrl = useMemo((): string | undefined => {
        const url: string | undefined = config.customContent?.seoContent?.url;

        if (!url) {
            return undefined;
        }
            
        const env: EnvConfig = config.customConfig?.env ?? EnvConfig.Stage;
        const userRoles: string = isLoggedIn ? 'loggedIn' : 'everyone';
        
        return replaceTemplateStringPlaceholders(url, {selectedLanguage, env, userRoles, disciplineName});
    }, [config.customConfig?.env, config.customContent?.seoContent?.url, disciplineName, isLoggedIn, selectedLanguage]);

    const payloads: string | undefined = config.customContent?.seoContent?.payloads;
    const routingUrl: string = `${config.customContent?.seoContent?.basePath ?? `/${selectedLanguage}/sport`}/${disciplineName}-${disciplineId}/${sportLocationName}-${sportLocationId}/location`;

    useEffect(() => {
        setActiveTab(undefined);
        setTournamentId('0');
    }, [disciplineId, sportLocationId]);

    const routeParamsMap: LocationNavItemRouteParamsMap | ParentNavItemRouteParamsMap = {
        ...(isHyphenatedFullUrl
            ? { sportLocationName: 'sportLocationName', }
            : { sportLocationShortName: 'sportLocationName' }),
        sportLocationId: 'sportLocationId',
        disciplineId: 'disciplineId',
        disciplineName: 'disciplineName',
    };

    const getTournamentParams: TournamentParams = {
        activeTab: activeTab,
        tournamentId: tournamentId,
        disciplineId: disciplineId,
        disciplineName: disciplineName,
        locationId: sportLocationId,
    };

    if (ready && sportLocationId === '0' && firstItemLocation?.id && isBrowser() && !displayAllTab) {
        history.replace(getPath(RouteNames.sportLocation, {
            disciplineName,
            disciplineId,
            sportLocationName: isHyphenatedFullUrl ? firstItemLocation?.name : firstItemLocation?.shortName,
            sportLocationId: firstItemLocation?.id,
        }));
    }

    return (
        <div>
            <Breadcrumbs
                disciplineId={disciplineId}
                locationId={sportLocationId}
                tournamentId={tournamentId !== '0' ? tournamentId : undefined}
                categoryId={eventCategoryId}
                isLarge={isLarge}
                routeType={sportPageType}
            />
            {ready &&
                <div className={'NavWrapper'}>
                    <SportsNav
                        activeItemId={disciplineId}
                        sportRoute={generateSportsPageUrl}
                        useStore={useStore}
                        className={`${SportsNavType.Popular}SportsNav`}
                        showIcon
                        hasArrows={deviceType === 'desktop'}
                        layoutType={LayoutType.Main}
                    />
                </div>
            }
            {!enabledNextRace &&
                <div className={navBem()}>
                    <LocationNav
                        disciplineId={disciplineId}
                        disciplineName={disciplineName}
                        liveStatus={DisciplineLiveStatus.NOT_LIVE}
                        routeName={RouteNames.sportLocation}
                        routeParamsMap={routeParamsMap}
                        genericId={activeLocation}
                        preventRedirect={false}
                        noRedirectFilter={handleLocation}
                        instanceId={`LocationNavSlice-${disciplineId}`}
                        hasArrows={deviceType === 'desktop'}
                        disabledAll={!displayAllTab}
                    />
                </div>
            }
            {enabledNextRace && (
                <>
                    <NextRaceBannerPage sportId={disciplineId} />
                    <NextRaceEventListPage sportId={disciplineId} />
                </>
            )}
            {sportLocationId && !enabledNextRace && !isShowAllLocationContent && (
                <MixedGroupedTournament
                    disciplineId={disciplineId}
                    locationId={sportLocationId}
                    tournamentId={tournamentId}
                    sportPageType={DisciplineRouteType.Location}
                    eventCategoryId={eventCategoryId}
                    activeTab={activeTab}
                    mainMarketsLimit={mainMarketsLimit}
                    deviceType={deviceType}
                    handleTournamentParams={handleSetTournamentParams}
                    tournamentParams={getTournamentParams}
                    handleActiveTabOutrights={handleActiveTabOutrights}
                    navLayout={enabledDisciplinePage}
                />
            )}
            {isShowAllLocationContent &&
                <SportAllLocationContent
                    instanceId={`All-${'Sport-' + disciplineId}-Custom`}
                    disciplineId={disciplineId}
                    locationId={sportLocationId}
                    breakpoints={breakpoints}
                    isTopBets={false}
                    isCategory={false}
                    mainMarketsLimit={mainMarketsLimit}
                />
            } 
            {seoUrl &&
                <CustomContentLoadLazy
                    url={seoUrl}
                    contentType={CustomContentType.NORMAL}
                    payloads={payloads}
                    filterBy={[['route', routingUrl]]}
                />
            }
        </div>
    );
}

const SportLocation: ComponentType<SportLocationPageStoreProps> = connect<SportLocationPageStoreProps, null, SportLocationPageProps, AppState>(
    (state: AppState, props: SportLocationPageProps): SportLocationPageStoreProps => {
        const { match: { params: { disciplineId } } } = props;
        const sliceName: string = getSliceName(locationNavSlice, `LocationNavSlice-${disciplineId}`);
        const slice: LocationNavStateModel | undefined = getSlice<LocationNavStateModel>(state, sliceName);
        const firstIdLocation = slice?.parts?.notLive?.list[0];

        return {
            isLarge: (state.breakpoints.large || state.breakpoints.xl),
            breakpoints: state.breakpoints,
            deviceType: state.deviceInfo?.platform.type,
            routing: state.routing,
            firstItemLocation: slice?.parts?.notLive?.items[firstIdLocation],
            isLoggedIn: !!state.session.info,
        };
    })(SportLocationPageComponent);
export default SportLocation;
